<template>
  <v-card class="okr-chart-card" elevation="0">
    <v-card-text class="pa-4">
      <div v-if="elementVisible && hasData">
        <vue-apex-charts type="donut" height="300" :options="chartOptions" :series="series"></vue-apex-charts>
      </div>
      <div v-else class="okr-chart-card__empty">
        <v-icon color="grey lighten-1">mdi-chart-donut</v-icon>
        <span>No hay información para el año y la semana seleccionados.</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'CumplimientoPL',
  props: {
    datos: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    series: [],
    chartOptions: {
      labels: ['Pendiente', 'Cumplido'],
      chart: {
        type: 'donut',
        toolbar: {
          show: false
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          let valor = parseFloat(val).toFixed(0);
          return valor + '%';
        }
      },
      title: {
        text: 'Cumplimiento general',
        align: 'center',
        margin: 5,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '18px',
          fontWeight: 'normal',
          fontFamily: 'Roboto, Helvetica, Arial',
          color: 'rgba(0, 0, 0, 0.8)'
        }
      },
      legend: {
        show: true,
        position: 'top',
        fontSize: '14px',
        fontFamily: 'Roboto, Helvetica, Arial',
        markers: {
          width: 14,
          height: 14,
          strokeWidth: 0,
          strokeColor: '#fff',
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
        labels: {
          colors: '#424242',
          useSeriesColors: false
        },
        itemMargin: {
          horizontal: 15,
          vertical: 5
        },
        onItemHover: {
          highlightDataSeries: true
        },
        onItemClick: {
          toggleDataSeries: true
        }
      },
      grid: {
        padding: {
          left: 4,
          right: 4
        },
        borderColor: 'rgba(0,0,0,0.5)'
      },
      plotOptions: {
        pie: {
          customScale: 1.0,
          donut: {
            size: '65%',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '18px',
                color: undefined,
                offsetY: -10
              },
              value: {
                show: true,
                color: '#99abb4',
                formatter: function(w) {
                  return w + '%';
                }
              },
              total: {
                show: true,
                label: 'Cumplido',
                color: '#6b7280',
                formatter: function(w) {
                  return w.globals.seriesTotals[1] + '%';
                }
              }
            }
          }
        }
      },
      stroke: {
        width: 1,
        colors: 'rgba(0,0,0,0.1)'
      },
      colors: ['#d90429', '#10b981'],
      tooltip: {
        fillSeriesColor: false,
        y: {
          formatter: function(value) {
            return value + '%';
          }
        }
      },
      responsive: []
    },
    elementVisible: false,
    hasData: false
  }),
  computed: {
    getseries() {
      return this.series;
    }
  },
  watch: {
    async datos(val) {
      let sumaCumplimiento = 0;
      let cumplimiento = 0;
      let realizadas = 0;
      let norealizadas = 0;
      if (val.totaltareasareas != undefined) {
        if (val.totaltareasareas.length > 0) {
          let s1 = 0;
          let s2 = 0;
          let cont = 0;
          await val.totaltareasareas.forEach((element) => {
            const actividadesRealizadas = Number(element.actividadesrealizadas) || 0;
            const actividadesNoRealizadas = Number(element.actividadesnorealizadas) || 0;

            if (actividadesRealizadas + actividadesNoRealizadas <= 0) {
              return;
            }

            cont++;
            sumaCumplimiento += Number(element.cumplimiento) || 0;
          });
          cumplimiento = cont > 0 ? sumaCumplimiento / cont : 0;
          realizadas = parseInt(cumplimiento);
          norealizadas = parseInt(100 - realizadas);
          s1 = realizadas;
          s2 = norealizadas;
          this.series = [s2, s1];
          this.hasData = cont > 0;
        } else {
          this.series = [];
          this.hasData = false;
        }
        this.elementVisible = true;
      }
    }
  },
  mounted() {
    const primary = (this.$vuetify && this.$vuetify.theme.currentTheme.primary) || '#d90429';
    this.chartOptions = {
      ...this.chartOptions,
      colors: [primary, '#10b981']
    };
  },
  created() {},
  components: {
    VueApexCharts
  }
};
</script>

<style lang="scss" scoped>
.okr-chart-card {
  border: 1px solid #e5e8ef;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  margin-bottom: 0;
  overflow: hidden;
}

.okr-chart-card__empty {
  align-items: center;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 8px;
  justify-content: center;
  min-height: 300px;
  text-align: center;
}
</style>
